<template>
  <BaseEditableLayout
    class="container"
    :panels="panels"
    :padding="10"
    border-radius
  />
</template>

<script>
import $bus from '@/vue-plugins/bus';
export default {
  mounted() {
    this.$store.dispatch('session/whoami').then((res)=>{
      $bus.$emit('login', {});
    });
  },
  computed: {
    panels() {
      return [{
        x: 0, y: 0, w: 6, h: 3, control: 'PanelWeather',
      },
      {
        x: 0, y: 3, w: 5, h: 3, control: 'PanelWeather',
      },
      {
        x: 0, y: 6, w: 4, h: 3, control: 'PanelWeather',
      },
      {
        x: 6, y: 0, w: 6, h: 2, control: 'PanelWeather',
      },
      {
        x: 6, y: 3, w: 6, h: 2, control: 'PanelWeather',
      },
      {
        x: 6, y: 6, w: 6, h: 1, control: 'PanelWeather',
      },
      {
        x: 6, y: 7, w: 6, h: 0.5, control: 'PanelWeather',
      },
      {
        x: 6, y: 8, w: 6, h: 0.3, control: 'PanelWeather',
      },
      {
        x: 12, y: 0, w: 6, h: 2, control: 'PanelWeather',
      },
      {
        x: 12, y: 3, w: 6, h: 2, control: 'PanelWeather',
      },
      {
        x: 12, y: 6, w: 6, h: 2, control: 'PanelWeather',
      },

        // {
        //   x:6,y:0,w:12,h:7,control:"PanelCalendar"
        // }
      ];
    },
  },
};
</script>
